<script lang="ts" setup>

	import Multiselect from 'vue-multiselect';
	import {useI18n} from 'vue-i18n';

	const {t} = useI18n();

	defineProps<{
		preferredDeliveryDay: number | null;
	}>();

	const emit = defineEmits(['on-preferred-delivery-day-change']);

	const availableDeliveryDays = [1, 2, 3, 4, 5];

	const getPreferredDeliveryDayLabel = (deliveryDay: string) => {
		return t(`shoppingcart.generic.preferredDeliveryDay.option.${deliveryDay}`);
	};

	const updatePreferredDeliveryDay = (deliveryDay: number) => {
		emit('on-preferred-delivery-day-change', deliveryDay);
	};

</script>

<template>
	<div class="input-wrapper">
		<label for="po-select-preferred-delivery-day">
			{{ t('shoppingcart.modal.createpo.content.addPreferredDeliveryDay.select.label') }}
		</label>

		<multiselect id="po-select-preferred-delivery-day"
		             :custom-label="getPreferredDeliveryDayLabel"
		             :model-value="preferredDeliveryDay"
		             :options="availableDeliveryDays"
		             :placeholder="t('shoppingcart.modal.createpo.content.addPreferredDeliveryDay.select.placeholder')"
		             :searchable="true"
		             :show-labels="false"
		             deselect-label=""
		             select-label=""
		             selected-label=""
		             @update:model-value="updatePreferredDeliveryDay" />

		<p v-if="!preferredDeliveryDay"
		   class="modal-wrapper__preferred-delivery-day-week-unavailable">
			{{ t('shoppingcart.modal.createpo.content.addPreferredDeliveryDay.label') }}
		</p>
	</div>
</template>
